import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import {Paper, Typography} from '@mui/material';



const styleSheet = theme => ({
    paper: {
        marginTop: 32,
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        color: theme.palette.text.secondary,
    }
});
  
class AccountSuspendMsg extends Component {
    

  render() {
      const classes = this.props.classes;
      if ((this.props.accountType === 3 || this.props.accountType === "3") && (this.props.accountStatus === 1 || this.props.accountStatus === "1")) {
        //suspended reseller
        return (
          <Paper className={classes.paper} elevation={0} >
            <div >
              <Typography variant="h6">
                Suspended account
              </Typography>
              <Typography variant="body2">
                Your account has been suspended. You can review past activity, but cannot add customers, add funding sources, or purchase subscriptions through AppBind. Please contact support to learn how to recover your account.
              </Typography>
  
            </div>
  
          </Paper>
        );  

      } else if ((this.props.accountType === 3 || this.props.accountType === "3") && (this.props.accountStatus === 2 || this.props.accountStatus === "2")) {
        //pending reseller
        return (
          <Paper className={classes.paper} elevation={0} >
            <div >
              <Typography variant="h6">
                Getting to know you better
              </Typography>
              <Typography variant="body2">
                We're excited that you've signed up for AppBind! While we're getting to know you better and are verifying your account, you'll be able to add customers and start setting up subscriptions. However, you won't be able to add funding sources or pay for subscriptions with AppBind cards until your account is activated. Please contact support if you have any questions; otherwise, you'll be hearing from us soon on next steps.
              </Typography>
  
            </div>
  
          </Paper>
        );  
    
          
      } else {
        return null;
      }


  }
}

export default withStyles(styleSheet)(AccountSuspendMsg);